<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/IZHQkP/tc-custom/9781609459444.jpg?1701632877936" alt="This image is the cover for the book Zulu"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Zulu
      </h1>
      <p class="bookDescription body article font2">
        <b>A Cape Town cop takes on the media-frenzied murder of a young woman in this “hard-hitting procedural, which won France’s Grand Prix for Best Crime Novel” (<i>Publishers Weekly</i>).</b><br/>  <br/> As a child, Ali Neuman ran away from home to escape the Inkatha, a militant political party at war with the then-underground African National Congress. He and his mother are the only members of his family who survived the carnage of those years. Today, Neuman is chief of the homicide branch of the Cape Town police, a job in which he must do battle with South Africa’s two scourges: widespread violence and AIDS.<br/>  <br/> When the mutilated corpse of a young white woman is found in the city’s botanical gardens, Neuman finds himself chasing one false lead after another. Then a second corpse is found—another white woman. This time, the body bears signs of a Zulu ritual. Worse, an unknown narcotic has been found in the blood of both victims.<br/>  <br/> The investigation will take Neuman back to his homeland, where he will discover that the once bloody killing fields have become a refuge for unscrupulous multinationals, and that the apparatchiks of apartheid still lurk in the shadows of a society struggling toward reconciliation.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Caryl Férey, Howard Curtis
      </h2>
      
      <p class="authorDescription body article">Caryl Férey's first novel to be published in English, Zulu (Europa Editions 2010), was the winner of the Nouvel Obs Crime Fiction and the Quais du Polar Readers Prizes. In 2008, it was awarded the French Grand Prix for Best Crime Novel. Utu (Europa Editions, 2011) won the Sang d'Encre, Michael Lebrun, and SNCF Crime Fiction Prizes. This is his third work of crime fiction to be published by Euorpa Editions. He lives in France.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Europa Editions
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?39854930